<script setup lang="ts">
  defineOptions({ name: 'EventRegisteredBadge' })

  import { useI18n } from 'vue-i18n'

  import { createElementId } from '@common/core-layer/utils'

  import CPTag from '@ui/components/CPTag.vue'
  import CPText from '@ui/components/CPText.vue'

  defineProps({
    idPrefix: {
      type: String,
      required: true,
    },
    eventId: {
      type: String,
      required: true,
    },
  })

  const { t } = useI18n()
</script>

<template>
  <CPTag :id="createElementId(idPrefix, eventId, 'registered')" size="xs" color="success" :bordered="false" :interactive="false">
    <CPText size="xs" weight="bold">{{ t('clientportal.events.registered') }}</CPText>
  </CPTag>
</template>
